module.exports = __webpack_public_path__ + "img/1791992454733.31da66b8.png";